/** The AI banks' seat ids, from the board, while the finale has not yet reached the reveal: the replay shows them anonymised until then (F16.5 H). */
import { FINALE_STAGES } from "@bsim/contracts";
import { useRoute } from "../api/context";

type Stage = (typeof FINALE_STAGES)[number];

export function useHiddenAiSeats(cohortId: string, stage: Stage): ReadonlySet<string> | "all" {
  const board = useRoute("cohortBoard", { cohortId });
  if (FINALE_STAGES.indexOf(stage) >= FINALE_STAGES.indexOf("aiReveal")) return new Set();
  // While the board loads the AI seats are not known: hide every seat rather than flash their names.
  if (board.data === undefined) return "all";
  return new Set((board.data?.teams ?? []).filter((t) => t.isAi).map((t) => t.seatId));
}
